const styles = `:host {
  border-bottom: none;
}
:host div[part=heading] {
  color: var(--goto-text-01);
  height: 36px;
  align-items: center;
  display: grid;
  position: relative;
  grid-template-columns: auto 1fr auto 40px;
  border: 1px solid transparent;
}
:host div[part=heading] button {
  color: var(--goto-text-01);
  font: var(--goto-body-small);
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  grid-area: 1/2/auto/auto;
  padding: 0 16px;
  text-align: left;
}
:host div[part=heading] button::before {
  border: 1px solid transparent;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
:host div[part=heading]:hover {
  background-color: var(--goto-hover-secondary);
}
:host div[part=heading] button:focus-visible::before {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
  outline: none;
}
:host div[part=heading]:active {
  background-color: var(--goto-pressed-secondary);
}
:host div[part=heading] .icon {
  display: inline-grid;
  grid-column: 4/auto;
}
:host .start {
  --goto-icon-color: var(--goto-icon-04);
  --goto-icon-size: var(--goto-spacing-04);
  height: var(--goto-spacing-04);
  width: var(--goto-spacing-04);
  display: grid;
  margin-left: var(--goto-spacing-04);
  place-items: center;
}
:host .region {
  display: none;
}
:host [name=expanded-icon],
:host [name=collapsed-icon] {
  --goto-icon-color: var(--goto-icon-04);
  --goto-icon-size: var(--goto-spacing-04);
}
:host [name=collapsed-icon] {
  display: contents;
}
:host [name=expanded-icon] {
  display: none;
}

:host([size=small]) div[part=heading] {
  height: var(--goto-spacing-06);
  font: var(--goto-caption-default-01);
}
:host([size=small]) [name=expanded-icon],
:host([size=small]) [name=collapsed-icon],
:host([size=small]) .start {
  --goto-icon-size: var(--goto-spacing-04);
}

:host([size=large]) div[part=heading] {
  height: var(--goto-spacing-09);
  font: var(--goto-body-medium);
}
:host([size=large]) [name=expanded-icon],
:host([size=large]) [name=collapsed-icon],
:host([size=large]) .start {
  --goto-icon-color: var(--goto-icon-04);
  --goto-icon-size: var(--goto-spacing-04);
}

:host(.expanded.has-stepper-badge) .region {
  padding: 16px 56px;
}

:host(.expanded) .region {
  display: block;
  padding: 16px 56px 16px 16px;
}
:host(.expanded) [name=collapsed-icon] {
  display: none;
}
:host(.expanded) [name=expanded-icon] {
  display: contents;
}

:host([fullwidth]) .region,
:host([fullwidth].expanded.has-stepper-badge) .region {
  padding: 0;
}

::slotted(chameleon-navigation-drawer-item) {
  width: 100%;
  padding-left: var(--goto-spacing-09);
}`; export default styles;